// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/kernel/capabilities.ts
// Parameters       : none — this file is byte-identical across the fleet
// Destination      : packages/fleet/kernel/src/capabilities.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo kid-games-app
//     node fleet/fleet.ts check --repo kid-games-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * What the current runtime can actually do. A plugin declares what it needs and
 * the kernel decides whether to mount it; nothing in a plugin ever asks
 * "am I in Tauri?".
 */

export type PlatformTarget = "web" | "tauri" | "ssr";

export type Capability =
  /** There is a DOM and a user looking at it. */
  | "window"
  /** There is a per-account local database (PowerSync) to read from. */
  | "localDb"
  /** Real file system access (Tauri only). */
  | "fileSystem"
  /** OS-level notifications. */
  | "notifications"
  /**
   * The OS can hand the app a deep link (App/Universal Links). Native runtimes
   * only: on the web the equivalent arrives as an ordinary route.
   */
  | "deepLinks";

export type CapabilitySet = Record<Capability, boolean>;

export const CAPABILITIES: Record<PlatformTarget, CapabilitySet> = {
  web: {
    window: true,
    localDb: true,
    fileSystem: false,
    notifications: true,
    deepLinks: false,
  },
  tauri: {
    window: true,
    localDb: true,
    fileSystem: true,
    notifications: true,
    deepLinks: true,
  },
  ssr: {
    window: false,
    localDb: false,
    fileSystem: false,
    notifications: false,
    deepLinks: false,
  },
};

/**
 * Detection is deliberately dumb and dependency-free: the host passes the
 * target explicitly wherever it already knows it (`isTauriRuntime()`), and this
 * is only the fallback.
 */
export function detectTarget(): PlatformTarget {
  if (typeof window === "undefined") {
    return "ssr";
  }
  return "__TAURI_INTERNALS__" in globalThis ? "tauri" : "web";
}
